import { render } from "./GruposAdmin.vue?vue&type=template&id=38bee2a4"
import script from "./GruposAdmin.vue?vue&type=script&lang=js"
export * from "./GruposAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__